import { useServicesContext } from "@/modules/core/services/services.context"
import type { StripePlatform } from "@/modules/payment/stripeTypes"
import { useQueryClient } from "@tanstack/react-query"

export const useStripePlatform = () => {
  const { paymentService } = useServicesContext()
  const queryClient = useQueryClient()

  const getStripePublicKey = (stripePlatform: StripePlatform) => {
    return queryClient.fetchQuery({
      queryKey: ["stripePlatform"],
      queryFn: () => paymentService.getStripePublicKey(stripePlatform),
    })
  }

  return { getStripePublicKey }
}
